module.exports = __webpack_public_path__ + "static/media/dzon.8e3e3430.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dzon.png
// module id = 383
// module chunks = 0 1